import React from 'react';
import { Paper } from '@mui/material';
import { Link } from 'react-router-dom';


const FacultyCard = ({ faculty }) => {

    return (
        <>
            {
                faculty?.length > 0 ? faculty?.map((item, index) => {
                    return (
                        <div className="p-1 col-md-2" key={index}>
                            <Paper elevation={5} sx={{ borderRadius: '0%', minHeight: '250px' }} >
                                <div className='text-center p-2 d-flex justify-content-center align-items-center' style={{ height: '300px', overflow: 'hidden' }}>
                                    <img src={`${process.env.REACT_APP_BACKEND}assets/faculty/${item.photo}`} className='col-12' alt={item?.name} />
                                </div>
                                <hr className='m-0' />
                                <div className="m-2 p-2 text-center" style={{ minHeight: '150px' }}>
                                    <div> <b> {item?.name}</b> </div>
                                    <div> <small> {item?.qualification} </small></div>
                                    <div> <b> {item?.designation} </b></div>
                                    {/* <div> dashbd</div> */}
                                    {/* <Link to="/Publication"> View Publication</Link> */}
                                </div>
                            </Paper>
                        </div>
                    )
                }) :
                    <div className='p-5 text-center'>
                        {/* <img src={require('/assets/nodata.jpg')} /> */}
                        <h4>No Faculties Found</h4>
                    </div>
            }
        </>
    )
}

export default FacultyCard;